import api from '../../../shared/utils/api';

const testCaseApi = {
  getTestCases: (workflowId) => api.get('/api/test-cases', { params: { workflowId } }),
  getTestCase: (id) => api.get(`/api/test-cases/${id}`),
  generateTestCases: (data) => api.post('/api/test-cases/generate', data),
  updateTestCase: (id, data) => api.put(`/api/test-cases/${id}`, data),
  toggleComplete: (id) => api.patch(`/api/test-cases/${id}/toggle`),
  reportBug: (data) => api.post('/api/test-cases/bugs', data),
  getBugs: (workflowId) => api.get('/api/test-cases/bugs', { params: { workflowId } }),
};

export default testCaseApi;
